import { memo } from 'react';
import { Box, Icon } from '@chakra-ui/react';

import BlocksIcon from 'components/Icons/BlocksIcon';
import BlocksIconActive from 'components/Icons/BlocksIconActive';
import DimensionsIcon from 'components/Icons/DimensionsIcon';
import DimensionsIconActive from 'components/Icons/DimensionsIconActive';
import ImportDataIcon from 'components/Icons/ImportDataIcon';
import ImportDataIconActive from 'components/Icons/ImportDataIconActive';
import DashboardIcon from 'components/Icons/DashboardIcon';
import DashboardIconActive from 'components/Icons/DashboardIconActive';

import { NavigationMenuProperties } from '../types';
import { COLORS, BUTTON_STYLES } from '../constants';

const NavigationMenu = memo(({ icon, label, isActive, onClick }: NavigationMenuProperties) => {
  // Check if icon is BlocksIcon, DimensionsIcon, or ImportDataIcon component
  const isBlocksIcon = icon === BlocksIcon || (icon as any)?.name === 'BlocksIcon';
  const isDimensionsIcon = icon === DimensionsIcon || (icon as any)?.name === 'DimensionsIcon';
  const isImportDataIcon = icon === ImportDataIcon || (icon as any)?.name === 'ImportDataIcon';
  const isDashboardIcon = icon === DashboardIcon || (icon as any)?.name === 'DashboardIcon';

  const renderIcon = (): JSX.Element => {
    if (isDashboardIcon) {
      return (
        <Box boxSize={5} display='flex' alignItems='center' justifyContent='center'>
          {isActive ? (
            <DashboardIconActive width={20} height={20} />
          ) : (
            <DashboardIcon width={20} height={20} />
          )}
        </Box>
      );
    }
    if (isBlocksIcon) {
      return (
        <Box boxSize={5} display='flex' alignItems='center' justifyContent='center'>
          {isActive ? (
            <BlocksIconActive width={20} height={20} />
          ) : (
            <BlocksIcon width={20} height={20} />
          )}
        </Box>
      );
    }
    if (isDimensionsIcon) {
      return (
        <Box boxSize={5} display='flex' alignItems='center' justifyContent='center'>
          {isActive ? (
            <DimensionsIconActive width={20} height={20} />
          ) : (
            <DimensionsIcon width={20} height={20} />
          )}
        </Box>
      );
    }
    if (isImportDataIcon) {
      return (
        <Box boxSize={5} display='flex' alignItems='center' justifyContent='center'>
          {isActive ? (
            <ImportDataIconActive width={20} height={20} />
          ) : (
            <ImportDataIcon width={20} height={20} />
          )}
        </Box>
      );
    }
    return (
      <Icon as={icon} boxSize={5} color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT} />
    );
  };

  return (
    <Box flexShrink={0}>
      <Box
        as='div'
        display='inline-flex'
        alignItems='center'
        justifyContent='center'
        cursor='pointer'
        px='24px'
        py='10px'
        {...BUTTON_STYLES}
        borderRadius='full'
        color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT}
        bg={isActive ? COLORS.ACTIVE_BG : 'transparent'}
        _hover={{ bg: isActive ? COLORS.ACTIVE_HOVER : 'gray.100' }}
        _active={{ bg: isActive ? COLORS.ACTIVE_PRESSED : 'gray.200' }}
        onClick={onClick}
        height={'31px'}
        fontSize='12px'
        fontWeight='500'
      >
        {renderIcon()}
        <Box as='span' ml={2}>
          {label}
        </Box>
      </Box>
    </Box>
  );
});

NavigationMenu.displayName = 'NavigationMenu';

export default NavigationMenu;
